"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Raven = _interopRequireDefault(require("Raven"));

var _default = function _default(store) {
  return function (next) {
    return function (action) {
      next(action);

      _Raven.default.setUser(store.getState());
    };
  };
};

exports.default = _default;
module.exports = exports.default;